/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import {
  Component,
} from '@angular/core';

import { CheckoutScheduleReplenishmentOrderComponent } from '@spartacus/checkout/scheduled-replenishment/components';

@Component({
  selector: 'cx-schedule-replenishment-order',
  templateUrl: './gonvarri-checkout-schedule-replenishment-order.component.html',
  standalone: false,
})
export class GonvarriCheckoutScheduleReplenishmentOrderComponent extends CheckoutScheduleReplenishmentOrderComponent
{

  getSelectValue(event: Event): string {
    return (event.target as HTMLSelectElement)?.value;
  }

  getInputValue(event: Event): string {
    return (event.target as HTMLInputElement)?.value;
  }

  getCheckboxChecked(event: Event): boolean {
    return (event.target as HTMLInputElement)?.checked;
  }
}
